import { render, staticRenderFns } from "./sin_upCom.vue?vue&type=template&id=3a6908fd&scoped=true"
import script from "./sin_upCom.vue?vue&type=script&lang=js"
export * from "./sin_upCom.vue?vue&type=script&lang=js"
import style0 from "./sin_upCom.vue?vue&type=style&index=0&id=3a6908fd&prod&lang=scss&scoped=true"
import style1 from "./sin_upCom.vue?vue&type=style&index=1&id=3a6908fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6908fd",
  null
  
)

export default component.exports